import { jsx } from 'react/jsx-runtime';
import { i18n } from '../../../utils/i18n.js';
import { TourStep } from '../components/tour-step.js';

const styles = {
  popover: (base) => ({
    ...base,
    borderRadius: "8px"
    // mili
  }),
  maskArea: (base) => ({
    ...base,
    rx: 8
    // mili
  }),
  badge: (base) => ({
    ...base,
    backgroundColor: "#239bf6"
    // info-medium
  })
};
const badgeContent = ({
  totalSteps,
  currentStep
}) => `${currentStep + 1}/${totalSteps}`;
const MENU_ANCHOR = 'div[aria-label="Abrir Menu"] > button';
const TOOLBAR_ANCHOR = 'div[aria-label="Barra de ferramentas"]';
const getMenuSteps = (ref, setOnboardingShowed) => [{
  selector: ref ? ref?.current.querySelector(MENU_ANCHOR) : MENU_ANCHOR,
  content: /* @__PURE__ */ jsx(TourStep, { title: i18n._(
    /*i18n*/
    {
      id: "zucql+"
    }
  ), description: i18n._(
    /*i18n*/
    {
      id: "OpJoOS"
    }
  ) }),
  position: [14, 100]
}, {
  selector: ref ? ref.current.querySelector(TOOLBAR_ANCHOR) : TOOLBAR_ANCHOR,
  content: /* @__PURE__ */ jsx(TourStep, { title: i18n._(
    /*i18n*/
    {
      id: "mJeRW7"
    }
  ), description: i18n._(
    /*i18n*/
    {
      id: "aeXqc5"
    }
  ) }),
  actionAfter: () => setOnboardingShowed?.()
}];

export { MENU_ANCHOR, TOOLBAR_ANCHOR, badgeContent, getMenuSteps, styles };
